import * as yup from "yup";

const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const createAddAthleteSchema = (t) => {
    const athleteSchema = yup.object().shape({
        first_name: yup.string().trim().required(t("validation.firstNameRequired")),
        last_name: yup.string().trim().required(t("validation.lastNameRequired")),
        dob: yup
            .date()
            .typeError(t("validation.dobRequired"))
            .required(t("validation.dobRequired")),
        gender: yup
            .string()
            .transform((value, originalValue) => {
                return originalValue === "" ? null : value;
            })
            .oneOf(
                ["Male", "Female", "Other"],
                t("validation.genderMustBeOneOf")
            )
            .nullable()
            .optional(),
        email: yup
            .string()
            .trim()
            .lowercase()
            .email(t("validation.emailInvalid"))
            .transform((value, originalValue) =>
                originalValue === "" ? null : value
            )
            .nullable()
            .optional(),
        phone: yup
            .string()
            .trim()
            .transform((value, originalValue) =>
                originalValue === "" ? null : value
            )
            .matches(phoneRegExp, {
                message: t("validation.phoneInvalid"),
                excludeEmptyString: true,
            })
            .nullable()
            .optional(),
        school: yup.string().trim().required(t("validation.schoolRequired")),
        grad_year: yup
            .number()
            .transform((value, originalValue) => {
                return originalValue === "" ? null : value;
            })
            .integer(t("validation.mustBeInteger"))
            .typeError(t("validation.mustBeNumber"))
            .min(1900, t("validation.invalidYear"))
            .max(new Date().getFullYear() + 10, t("validation.invalidYear"))
            .nullable()
            .optional(),
        sport: yup
            .string()
            .trim()
            .transform((value, originalValue) =>
                originalValue === "" ? null : value
            )
            .optional()
            .nullable(),
        position: yup
            .string()
            .trim()
            .transform((value, originalValue) =>
                originalValue === "" ? null : value
            )
            .optional()
            .nullable(),
        previous_concussion_count: yup
            .number()
            .transform((value, originalValue) => {
                return originalValue === "" ? null : value;
            })
            .nullable()
            .typeError(t("validation.mustBeNumber"))
            .integer(t("validation.mustBeInteger"))
            .min(0, t("validation.cannotBeNegative"))
            .optional(),
    });

    return yup.object().shape({
        athletes: yup.array().of(athleteSchema),
    });
};

export default createAddAthleteSchema;